import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { displayToastSuccess } from '@/helpers';
import { useApiError } from '@/modules/common/hooks/use-api-error';
import { invalidateTimeOffSettingsQueries } from '@/modules/common/utils/query-invalidation';

import { updateTimeOffType, UpdateTimeOffTypePayload } from '../../api/time-offs.api';

interface UseUpdateTimeOffTypeParams {
  id: number;
  onSuccess?: () => void;
}

export const useUpdateTimeOffType = ({ id, onSuccess }: UseUpdateTimeOffTypeParams) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('authenticated.settings');
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: (payload: UpdateTimeOffTypePayload) => updateTimeOffType(id, payload),
    onSuccess: async () => {
      await invalidateTimeOffSettingsQueries(queryClient);
      displayToastSuccess(t('pages.timeOff.details.toasts.updateSuccess'));
      onSuccess?.();
    },
    onError: (error: Error) =>
      displayToastErrorFromApiWithFallback(error, 'pages.timeOff.details.toasts.updateError'),
  });
};
